import React, { useState } from 'react'
import IssueSolution from '../IssueSolution'
import IssueSolutionMeta from './IssueSolutionMeta'
import IssueSolutionLabel from './IssueSolutionLabel'
import { useParams, useLocation, Link } from 'react-router-dom'
import { useUser } from '../../context/user'
import { calcReadingTime, milisToMinutesOrSeconds, pluralize } from '../../utils/util'
import '../../styles/ImmediateIssueSolutions.css'
import i18n from '../../i18n'
import { t } from 'i18next'
import TaskMascot from '../../svg/UpstriveTaskMaskot'
import { ReactComponent as LeftArrow } from '../../svg/normalSvgs/LeftArrow.svg'

export default function ImmediateIssueSolutions(props) {
    const { user } = useUser()
    const { issueTopic, solutions } = useLocation().state
    const [issueSolutions, setIssueSolutions] = useState(solutions)
    const { id } = useParams()
    const [selectedSolution, setSelectedSolution] = useState(solutions[0])

    const IssueSolutionItem = ({ solution }) => {
        const numOfLikes = solution.likes
        const liked = solution.userLikes?.includes(user.id)
        const soundDuration = solution.audio_file && solution.audio_file.duration
        const hasLabel = solution.expert_recommendation
        const calcEstimatedTime = () => {
            if (soundDuration) {
                return milisToMinutesOrSeconds(soundDuration)
            } else {
                const readingTime = calcReadingTime(solution.text_body)
                return `${readingTime} ${pluralize('minute', readingTime)} read`
            }
        }

        return (
            <div
                className={`solution-item-container ${selectedSolution === solution ? 'selected-solution' : ''}`}
                onClick={() => {
                    var myDiv = document.getElementById('immedia-solution-scroll')
                    myDiv?.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                    })
                    setSelectedSolution(solution)
                }}
            >
                {hasLabel && <IssueSolutionLabel />}

                <div className="solution-item-title">{`\n${solution.title}`}</div>
                <div className="solution-item-text">
                    <span className="two-lines-txt">{solution.text_body}</span>
                </div>
                <div className="solution-item-text-meta">
                    <IssueSolutionMeta estimatedTime={calcEstimatedTime()} numOfLikes={numOfLikes} hasSound={!!soundDuration} liked={liked} />
                </div>
            </div>
        )
    }

    const pressLike = (solution) => {
        var index = solution.userDislikes?.indexOf(user.id)
        if (index !== -1) {
            solution.userDislikes = solution.userDislikes?.filter((e) => e != user.id)
        }
        solution.userLikes?.push(user.id)
        const indexOfSolution = issueSolutions.indexOf(solution)
        issueSolutions[indexOfSolution] = solution
        setIssueSolutions([...issueSolutions])
    }

    const pressDislike = (solution) => {
        var index = solution.userLikes.indexOf(user.id)
        if (index !== -1) {
            solution.userLikes = solution.userLikes.filter((e) => e != user.id)
        }
        solution.userDislikes.push(user.id)
        const indexOfSolution = issueSolutions.indexOf(solution)
        issueSolutions[indexOfSolution] = solution
        setIssueSolutions([...issueSolutions])
    }

    return (
        <div className={`issue-group-container  ${i18n.language == 'ar' ? 'ar-lang' : ''}`}>
            <div className="issue-group-main ">
                <div className="issue-group-section shadow-custom-soft">
                    {/* <TaskMascot className="task-mascot-solutions" /> */}
                    <div className="issue-group-section-title mb-25">
                        <span className={`issue-group-section-arrow ${i18n.language == 'ar' ? 'ar-transform' : ''}`}>
                            <Link to={`/solutions/${id}`}>
                                <LeftArrow className={i18n.language == 'ar' ? 'ar-transform' : ''} />
                            </Link>
                        </span>
                        <h2 className="issue-group-title">{t('thingsYouCanDoRightNow')}</h2>
                    </div>
                    <div className="issue-group-list issue-group-list-overflow grey-small-scroll">
                        {solutions.map((solution, i) => (
                            <IssueSolutionItem solution={solution} key={i} />
                        ))}
                    </div>
                </div>

                <div id="immedia-solution-scroll" className="issue-group-overview-section y-overflow ">
                    {selectedSolution && <IssueSolution solution={selectedSolution} pressLike={pressLike} pressDislike={pressDislike} issueTopic={issueTopic} />}
                </div>
            </div>
        </div>
    )
}
